"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'NewServicesList',
  bodyClass: 'list-users-system-page',
  components: {
    Card: _components.Card,
    FieldSearchInput: _components.FieldSearchInput,
    TableUsersList: _components.TableUsersList
  },
  data: function data() {
    return {
      search: '',
      page: 1,
      perPage: 10,
      pages: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listAllUsers'])), {}, {
    list: function list() {
      return _lodash.default.orderBy(this.listAllUsers, ['Name']);
    },
    filterClients: function filterClients() {
      var _this = this;
      if (this.search.length) {
        var searchLower = this.search.toLowerCase();
        return this.list.filter(function (p) {
          var name = p.personId.name || '';
          var CPF = p.personId.document || '';
          var mail = (p.personId.email || '').toUpperCase();

          // verifica se algum businessUnit contém o termo
          var businessMatch = p.businessUnits.some(function (item) {
            return item.toLowerCase().includes(searchLower);
          });
          return name.toUpperCase().includes(_this.search.toUpperCase()) || CPF.includes(_this.search.toUpperCase()) || mail.includes(_this.search.toUpperCase()) || businessMatch;
        });
      }
      return this.list;
    }
  }),
  created: function created() {
    this.fetchAllUsers();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchAllUsers'])), {}, {
    actionOpen: function actionOpen(item) {
      this.$router.push({
        path: "/users-detail/".concat(item.personId._id)
      });
    },
    addNew: function addNew() {
      this.$router.push({
        path: "/users-form"
      });
    }
  })
};